import { useEffect } from 'react';
import type { FmctOfferResponse } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

type ExecuteProps = {
  url: string;
};

export function useFmctOffer({ url }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<FmctOfferResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type FmctOfferRequest = ReturnType<typeof useFmctOffer>;
